import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ViewComingSoonRoutingModule} from './view-coming-soon-routing.module';
import {ViewComingSoonComponent} from './view-coming-soon.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [ViewComingSoonComponent],
  imports: [CommonModule, ViewComingSoonRoutingModule, TranslateModule],
  exports: [ViewComingSoonComponent],
})
export class ViewComingSoonModule {}
